import { getMessage } from '@tcc/i18n';
import { FdsConfirmationModal } from '../../../../containers/Modal/FdsConfirmationModal';

export type RemovePhotoConfirmationModalProps = {
  confirmTitleKey: string;
  onCancelGoBack: () => void;
  onClickCancel: () => void;
};

export const RemovePhotoConfirmationModal = ({
  confirmTitleKey,
  onCancelGoBack,
  onClickCancel,
}: RemovePhotoConfirmationModalProps) => (
  <FdsConfirmationModal
    dialogTestId='region-note-form-remove-photo-confirmation-modal'
    handleClickCancel={onClickCancel}
    handleClickGoBack={onCancelGoBack}
    title={getMessage(confirmTitleKey)}
    subTitle={getMessage('regionNote.form.removePhoto.warning.description')}
  />
);
